__turbopack_context__.v({
  "accordionItems": "BlockAccordion-module-scss-module__Bd16_a__accordionItems",
  "blockAccordion": "BlockAccordion-module-scss-module__Bd16_a__blockAccordion",
  "blockAccordionFlex": "BlockAccordion-module-scss-module__Bd16_a__blockAccordionFlex",
  "bodyCopyBlock": "BlockAccordion-module-scss-module__Bd16_a__bodyCopyBlock",
  "cta": "BlockAccordion-module-scss-module__Bd16_a__cta",
  "eyebrow": "BlockAccordion-module-scss-module__Bd16_a__eyebrow",
  "flushBottom": "BlockAccordion-module-scss-module__Bd16_a__flushBottom",
  "flushTop": "BlockAccordion-module-scss-module__Bd16_a__flushTop",
  "groupHeadline": "BlockAccordion-module-scss-module__Bd16_a__groupHeadline",
  "headline": "BlockAccordion-module-scss-module__Bd16_a__headline",
  "textBlock": "BlockAccordion-module-scss-module__Bd16_a__textBlock",
  "themeFAQ": "BlockAccordion-module-scss-module__Bd16_a__themeFAQ",
});
